import { getToken } from "../authorization/auth";
import { API_ENDPOINT } from "../authorization/const";

export async function getAllUsers() {
    const res = await fetch(API_ENDPOINT + "user/get-all/" + getToken());
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function getIdList(type) {
    const res = await fetch(API_ENDPOINT + "user/get-account/" + type + "/" + getToken());
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function newUser(json) {
    json["auth"] = getToken();
    const res = await fetch(API_ENDPOINT + "user/create", {
        method: "POST",
        body: JSON.stringify(json)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}
